import Axios from "axios";

const instance = Axios.create({
  timeout: 5000,
  baseURL:'/mainsys'
});

instance.interceptors.response.use(
  (response) => {
    if (/^[123]\d{2}/.test(response.status)) return response?.data;
    else {
      return Promise.reject(response);
    }
  },
  (error) => {
    //异常情况
    if (error.response.status) {
      switch (error.response.status) {
        // 403 token过期或未登录
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 401:
          Element.$message.error("登录过期，请重新登录");
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          Element.$message.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          Element.$message.error(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
);

export default instance;
